"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DVLTableCell = void 0;
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importStar(require("@opsbase/web-css"));
const react_1 = __importStar(require("react"));
const makeMyClasses = (alignItems, isFirstCol, width, padded) => ({
    cell: {
        display: 'flex',
        position: 'relative',
        alignItems: isFirstCol ? 'center' : alignItems,
        borderRight: '1px solid ' + lib_palette_1.default.BackgroundGrey.main,
        minHeight: 48,
        height: '100%',
        overflow: 'hidden',
        padding: padded ? 8 : undefined,
        width: padded ? '100%' : undefined,
    },
    lastCell: {
        borderRight: 0,
        width: 'auto !important',
        flex: '1 !important',
        minWidth: width,
    },
    staticCell: {
        flex: 1,
    },
    fieldCell: {
        flex: 'none',
        width: width,
    },
});
function DVLTableCell(props) {
    const { alignItems = 'flex-start', children, width, isFirstCol, isLastCol, isPinned, padded = false, className = '', onClick, onMouseEnter, onMouseLeave, } = props;
    const myCss = (0, web_css_1.default)(makeMyClasses, [alignItems, isFirstCol || isPinned, width, padded]);
    const myClassName = (0, web_css_1.cx)(myCss.cell, className, isLastCol ? myCss.lastCell : '', (isFirstCol || isPinned) ? myCss.staticCell : myCss.fieldCell);
    return (0, react_1.useMemo)(() => (react_1.default.createElement("div", { className: myClassName, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave }, children)), [children, myClassName, onClick, onMouseEnter, onMouseLeave]);
}
exports.DVLTableCell = DVLTableCell;
exports.default = DVLTableCell;
